// extracted by mini-css-extract-plugin
export default {"checkMark":"ContactConfirmation_checkMark__YjeBF","confirmationTitle":"ContactConfirmation_confirmationTitle__D0Kzf","confirmationBody":"ContactConfirmation_confirmationBody__s4BV-"};